
import { Context } from '@nuxt/types'
import { defineComponent } from 'vue'
import { PageData } from '@interfaces/PageDataTypes'
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'
import { DiagramStoreActions, DiagramTypes } from '~/domain/interfaces'
import HomePrompt from '~/components/homepage/HomePrompt.vue'
import CommonEducationBrandsBlock from '~/components/common/CommonEducationBrandsBlock.vue'
// import CommunityCardGrid from '~/components/community/CommunityCardGrid.vue'
// import HomeFeatures from '~/components/homepage/HomeFeatures.vue'
import HomeTestimonials from '~/components/homepage/HomeTestimonials.vue'
import HomePricing from '~/components/homepage/HomePricing.vue'

export default defineComponent({
  name: 'Homepage',
  components: {
    HomePrompt,
    CommonEducationBrandsBlock,
    // CommunityCardGrid,
    // HomeFeatures,
    HomeTestimonials,
    HomePricing,
  },
  extends: MachinationsLightPage,
  layout: 'machinations',

  async asyncData(context: Context) {
    const { $config, store } = context
    const { wpBaseURL } = $config

    await store.dispatch('common/setupHomepage', context)
    await store.dispatch('pricing/fetchPricingData', { context })
    const pageData = await store.dispatch('wp/fetchPageBySlug', {
      context,
      slug: 'homepage',
    })
    // await store.commit('wp/setPageNumer', 1)
    // await store.dispatch('wp/getPosts', { context, wpBaseURL })
    // await store.dispatch(DiagramStoreActions.GET_DIAGRAMS_OF_THE_MONTH, context)

    /* Fetch Popular Diagrams */
    await store.dispatch(DiagramStoreActions.GET_DIAGRAMS, {
      context,
      params: {
        diagramType: DiagramTypes.POPULAR,
        diagramPage: 1,
        authenticatedUser: store.getters.userIsAuthenticated,
        count: 8,
      },
    })

    /* Fetch Popular Designers */
    await store.dispatch('designers/fetchDesignersList', {
      context,
      page: 1,
      type: 'popular',
      authenticatedUser: store.getters.userIsAuthenticated,
      count: 8,
      getLastSeen: true,
      allUsersCount: true,
    })

    return {
      pageData
    }
  },

  data() {
    return {
      exploreLoading: false,
    }
  },

  head() {
    // @ts-ignore
    const pageHead = this.pageHead()
    const pageData = this.pageData as PageData
    const yoastDescription = pageData?.yoast_head_json?.description
    return {
      ...pageHead,
      title: `The Ultimate Game Design Platform`,
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          content: 'The Ultimate Game Design Platform',
        },
        {
          hid: 'description',
          name: 'description',
          content: yoastDescription,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: yoastDescription,
        },
        ...pageHead?.meta,
      ],
    }
  },
  computed: {
    /* Logo Belt data from WordPress ACF */
    logoBeltBlock(): any {
      const acf = this.$store.getters['wp/getAcfData'] || (this.pageData as any)?.acf
      const logoBeltBlock = acf?.blocks?.find(
        (b: any) => b.acf_fc_layout === 'common_education_brands_block' &&
                    b.block?.title?.text // has a title
      )?.block
      
      return {
        introIcons: {
          logo: (logoBeltBlock?.intro_icons?.logo || []).map((icon: any) => ({
            url: icon?.url || icon,
            alt: icon?.alt || icon?.title || 'Logo',
          })),
        },
        componentStyle: {
          paddingTop: 0,
          paddingBottom: 0,
          backgroundColor: 'transparent',
        }
      }
    },
    /* Logic reused from explore.vue to filter and display diagrams */
    exploreDiagrams() {
      // Just return the popular diagrams fetched
      return this.$store.state.diagrams.popular?.slice(0, 8)
    },
    exploreDesigners() {
      return this.$store.state.designers.designersList?.slice(0, 8)
    },
    highlightedDiagrams() {
      return this.$store.state.diagrams?.highlighted
    },
    DiagramTypes() {
      return DiagramTypes
    },
  },

  mounted() {
    document.addEventListener('contextmenu', this.preventContextMenu)
  },

  beforeDestroy() {
    document.removeEventListener('contextmenu', this.preventContextMenu)
  },

  methods: {
    goToCommunity(tab: string) {
      this.$router.push(`/community/see-all?filter=${tab}`)
    },
    preventContextMenu(event: Event) {
      if (event && event.target) {
        const button = (event.target as HTMLElement).closest('.v-btn') as HTMLElement;
        if (button) {
          event.preventDefault();
        }
      }
    },
  },
})
